module.exports = __webpack_public_path__ + "img/f03563e.jpg";